var TorsoView = require('backbone-torso/modules/View');
var documentTemplate = require('./documentTemplate.hbs');
var documentExtService = require('./../urls').documentExtService;
var PdfViewerModal = require('./../widget/pdf-viewer/PdfViewerModal');
var UseModalBehavior = require('./../widget/modal/UseModalBehavior');

/**
 * @class DocumentView
 * @constructor
 * @param option {Object}
 *   @param options.model {Torso.Model}
 */
module.exports = TorsoView.extend({
  moduleName: 'documentView',
  tagName: 'li',
  className: 'document-list-item',
  /**
   * @private
   * @property _pdfViewerModal {PdfViewerModal} The torso widget responsible for the rendering of the pdf modal
   * Set on initialize and never changed
   */
  _pdfViewerModal: null,
  template: documentTemplate,

  events: {
    'click [data-view-document]': 'viewDocument',
    'keypress [data-view-document]': 'viewDocument'
  },

  behaviors: {
    useModal: {
      behavior: UseModalBehavior
    }
  },

  /**
   * @method initialize
   * @override
   */
  initialize : function() {
    this._pdfViewerModal = new PdfViewerModal({pdfUrl : documentExtService + '/' + this.model.get('id')});
  },

  /**
   * @method viewDocument
   * Opens the pdf viewer widget to the
   */
  viewDocument: function(event) {
    event.preventDefault();
    this.showModal(this._pdfViewerModal);
  }
});
